<template>
    <div>
      <div v-for="(item, index) in lanPageList" :key="index">
      <div v-if="item.type == 0" style="font-size: 0px">
        <img :src="item.url" alt="" @click="lanPageClick(index)" class="land-page-img" />
      </div>
      <div v-else-if="item.type == 1">
        <video
          v-if="item.url"
          :poster="item.url"
          autoplay
          preload="auto"
          style="width: 100%"
          :muted="true"
          objectFit="cover"
          :loop="true"
          x5-video-player-type="h5"
          :src="item.url"
          webkit-playsinline="true"
          playsinline="true"
          @click="lanPageClick(index)"
        ></video>
      </div>
    </div>

    </div>
  </template>
  
  <script>
  import {
    getWeChatScheme,
    getLandPage
  } from "../../api";
  import {launchApp} from '../../utils/index';
  import { Base64 } from 'js-base64'
  
  export default {
    name: 'LandPage',
    data(){
      return {
        lanPageList: [],
        appletUrl: ""
      }
    },
    mounted() {
      this.getLandPageCode()
      document.addEventListener("WeixinJSBridgeReady", function (){ 
        video.play();
        // video.pause();//可以注释
    }, false)
    },
    methods: {
      getLandPageCode() {
        const code = this.$route.query.code
        let param
        code ? param = code : param = 'cotti-my-socialGroup-bg-banner-packging'
        this.$sensors.track('landPage_page_view', { positionCode: param });
        getLandPage({code: param}).then(res=> {
          console.log('res-----', res);
          if (res.data && res.data.resources && res.data.resources.length > 0) {
            const result = res.data
            document.title = result.name || ''
            this.lanPageList = result.resources || []
          }
        })
      },
      lanPageClick(index) {
        this.handleJumpAction(this.lanPageList[index].redirectUrl || null, this.lanPageList[index].h5JumpType || null)
        const code = this.$route.query.code
        let param
        code ? param = code : param = 'cotti-my-socialGroup-bg-banner-packging'
        this.$sensors.track('landPage_btn_click', { positionCode: param });
      },
      handleJumpAction(jumpLink, jumpType) {
        console.log(jumpLink, jumpType)
        if (jumpLink) {
          if (jumpType) {
            if (jumpType == 3 || jumpType == '3') {
                  this.appletUrl = jumpLink;
                  this.openApp(this.appletUrl)
                } else if (jumpType == 4 || jumpType == '4') {
                  this.appletUrl = jumpLink;
                  this.openApplet(this.appletUrl)
                } else if (jumpLink == 7) {
                  this.appletUrl = jumpLink
                  this.onAli(this.appletUrl)
                }
          } else {
            window.location.href = jumpLink;
          }
        }
      },
      openApplet(appletUrl) {
        try {
          const path = appletUrl.split('?')[0]
          const query = appletUrl.split('?')[1]
          const params = JSON.stringify({ path: appletUrl })
          getWeChatScheme({ path, query }).then(res => {
            if (res.data.scheme) {
              location.href = res.data.scheme;
            } else {
              this.$toast({ message: "请先安装微信" });
            }
          })
        }catch (e) {
          this.$toast({ message: "请先安装微信" });
        }
      },
      // 跳转app
      openApp(appletUrl) {
        const path = appletUrl.split('?')[0]
        const query = appletUrl.split('?')[1]
        const params = JSON.stringify({ path: appletUrl })
        launchApp('PAGES', Base64.encode(params), true)
      },
      // 跳转支付宝小程序
      onAli(appletUrl) {
        let params =`alipays://platformapi/startapp?appId=2021004123660926&page=/${appletUrl}`
        window.location.href = `https://ds.alipay.com/?scheme=${params}`
      },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .land-page-img{
    width: 100%;
  }
  </style>
  